module.exports = __webpack_public_path__ + "static/google_adwors-f76c9ab57e3b7f4ad5c526d5b6aa614c.webp";